import * as echarts from 'echarts';
import { useEffect, useRef } from "react";
import { IResponseSummarySites } from '../../../util/services/site';
import styles from "./style.module.scss";

interface IProps {
    data: IResponseSummarySites
}

const SiteUtilize: React.FC<IProps> = ({ data }) => {
    const chartRef = useRef<any>(null);
    const { inactive_sites, sites = {} } = data;
    const inactive_count = inactive_sites.length;

    useEffect(() => {
        if (chartRef.current) {
            const existInstance = echarts.getInstanceByDom(chartRef.current);
            if (existInstance) {
                echarts.dispose(chartRef.current)
            };
            const chart = echarts.init(chartRef.current);
            const option = {
                tooltip: {
                    trigger: 'item'
                },

                series: [
                    {
                        name: 'Site utilize',
                        type: 'pie',
                        label: {
                            show: false
                        },
                        labelLine: { show: false },
                        radius: ['0%', '80%'],
                        center: ['50%', '50%'],
                        data: [
                            { value: inactive_count, name: 'Inactive sites', itemStyle: { color: '#ABA89C' } },
                            { value: Object.keys(sites).length - inactive_count, name: 'Active sites', itemStyle: { color: '#7CB6B1' } },
                        ],
                        itemStyle: {
                            borderWidth: 2,
                            borderColor: '#fff'
                        }
                    }
                ]
            };
            chart.setOption(option);
        }
    }, [inactive_count, sites]);

    const name = inactive_sites.map(key => sites[key]).join(', ');
    return <div className={styles.section}>
        <div className={styles.headerSection}>
            Site utilize
        </div>
        <div className={styles.bodySection}>
            <div className="text-[20px]">
                {inactive_count} inactive {inactive_count > 1 ? 'sites' : 'site'}
            </div>
            <div ref={chartRef} className='w-full h-[100px] mt-[-6px]' />
            <div className="text-[15px] mt-[-6px] text-center limit-10-lines" title={name}>
                {name}
            </div>
        </div>
    </div>;
}

export default SiteUtilize;